module.exports = __webpack_public_path__ + "media/images/empty-review-38a20231af4369f3ab894bf97ede0970.png";